import { config } from "../config/config";
import { UserType } from "../types/user";
import { getAuthToken } from "./tokenService.service";

export const userService = {
  getUser: async (userId: number): Promise<UserType> => {
    const token = getAuthToken();

    const response = await fetch(`${config.baseURL}/users/${userId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to get user");
    }

    const json = await response.json();
    return json.data;
  },

  createUser: async (userData: any): Promise<void> => {
    const token = getAuthToken();

    const response = await fetch(`${config.baseURL}/users`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(userData),
    });

    if (!response.ok) {
      const err = await response.json();
      throw new Error(err.message || "Failed to create user");
    }
  },

  updateUser: async (userId: string, userData: any): Promise<void> => {
    const token = getAuthToken();

    const response = await fetch(`${config.baseURL}/users/${userId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(userData),
    });

    if (!response.ok) {
      const err = await response.json();
      throw new Error(err.message || "Failed to update user");
    }
  },

  deleteUser: async (userId: number): Promise<void> => {
    const token = getAuthToken();

    const response = await fetch(`${config.baseURL}/users/${userId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to delete user");
    }
  },
};
